import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/device/page', Object.assign({}, options, { params }));
//获取项目下的设备列表：下拉框数据用。
export const getProjectDeviceList = (params, options) =>
request.get('/api/device/selectList', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/device/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/device/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/device/save', params,options)

export const update = (params, options) =>
request.post('/api/device/update', params,options)

export const childNode = (params, options) =>
  request.get('/api/v4ward/dept/child-node', Object.assign({}, options, { params }));

export const userList = (params, options) =>
  request.get('/api/v4ward/user/user-list-by-dept', Object.assign({}, options, { params }));

export const copyDevice = (params, options) =>
  request.get('/api/device/copyDevice', Object.assign({}, options, { params }));

export const getProjectDept = (params, options) =>
  request.get('/api/device/getProjectDept', Object.assign({}, options, { params }));

export const getDeviceId = (params, options) =>
  request.get('/api/device/queryList', Object.assign({}, options, { params }));

//获取分页表头数据
export const getTableStructure = (params, options) =>
  request.get('/api/device/list-structure', Object.assign({}, options, { params }));


  export const submitFormData = (params, options) =>
  request.post('/api/device/saveData', params,options)

// 获取所属部门下拉框数据
export const treeByProjectDeptId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

// 获取设备下拉框数据
export const treeByProjectDeviceTypeId = (params, options) =>
  request.get('/api/devicetype/getDeviceTypeWeightingTree', Object.assign({}, options, { params }));
  // request.get('/api/devicetype/getDeviceTypetree', Object.assign({}, options, { params }));

// 获取设备下拉框数据
export const treeByProjectDeviceTypeId_ = (params, options) =>
  request.get('/api/devicetype/getDeviceTypetree', Object.assign({}, options, { params }));
  // request.get('/api/devicetype/getDeviceTypetree', Object.assign({}, options, { params }));

// 获取区域下拉框数据
export const treeByProjectAreaId = (params, options) =>
  request.get('/api/device/getAreaTree', Object.assign({}, options, { params }));

// 获取设备台账数据
export const getDeviceList = (params, options) =>
  request.get('/api/device/deviceAccountPage', Object.assign({}, options, { params }));